// Match seeds on the client (GDD §11): the setup's seed field and the random seed of a fresh or rematched war. The
// client picks the seed with crypto.getRandomValues; the room's sim does everything else with it.

import type { MatchSeed } from '@taxwar/net'
import { HudError } from '../../hud/errors'

/** MatchSeed is a uint32. */
export const SEED_MAX = 0xffff_ffff
const SEED_DIGITS = /^\d+$/

/** The seed field's content: blank (draw one at start), a valid seed, or text that is not a seed. */
export type SeedEntry = { readonly kind: 'random' } | { readonly kind: 'fixed'; readonly seed: MatchSeed } | { readonly kind: 'invalid' }

export const RANDOM_SEED: SeedEntry = { kind: 'random' }
const INVALID_SEED: SeedEntry = { kind: 'invalid' }

export function parseSeed(text: string): SeedEntry {
  const trimmed = text.trim()
  if (trimmed === '') return RANDOM_SEED
  if (!SEED_DIGITS.test(trimmed)) return INVALID_SEED
  const value = Number(trimmed)
  return value <= SEED_MAX ? { kind: 'fixed', seed: value as MatchSeed } : INVALID_SEED
}

/** A fresh uint32 match seed (a blank seed field, or a rematch replaying the setup on a new map). */
export function randomSeed(): MatchSeed {
  const words = crypto.getRandomValues(new Uint32Array(1))
  const seed = words[0]
  if (seed === undefined) throw new HudError('crypto.getRandomValues filled no seed word')
  return seed as MatchSeed
}
